/* eslint-disable no-unused-vars */
import React from 'react';
/* eslint-enable no-unused-vars */
import './HomeRunVideos.css';

// Disabled — Bluesky account (mlbhomeruns.bsky.social) is inactive.
// TODO: Re-enable with a working feed source for the 2026 season.
const HomeRunVideos = () => {
  return null;
};

export default HomeRunVideos;
